import ContentHeading from '../../../components/layout/content/ContentHeading'
import React, { useCallback, useEffect, useState } from 'react'
import TableRowCommon from '../../../components/table/TableRowCommon';
import TableCustom from '../../../components/table/tableCustom';
import InputTextField from '../../../components/input/inputTextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FilterSelect from '../../../components/select/filterSelect';
import { ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { setStep } from '../../../store/step-personal-management/step.slice';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import StatusCustom from '../../../components/status/statusCustom';
import DropdownButton from '../../../components/button/DropdownButton';
import { useTranslation } from 'react-i18next';
import { MenuItem, useMediaQuery } from '@mui/material';
import { EmployeeApi, listType } from '../../../api/employee/employee.api';
import { checkPermission, debouncedApiCall } from '../../../utils/app.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import moment from 'moment';
import { PersonalRecordState } from './manageState';
import { gender_data, gender_enum, gender_enum_en, status_employee_data } from './enum/enum-personnel';
import { OrganizationApi } from '../../../api/organization/organization.api';
import AutocompleteSelect from '../../../components/select/autoCompleteSelect';
import { languageEnum } from '../../../constants/enum';
import { ReportApi } from '../../../api/report/Report.api';
import { saveAs } from 'file-saver';
import { NationalityApi } from '../../../api/nationality/NationalityApi';
import { RootState } from '../../../store/store';

type Props = {}

const PersonnelManagement: React.FC<Props> = ({ }: Props) => {
    moment.locale('th');
    const matches = useMediaQuery('(min-width:1440px)');
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentLanguage: string = i18n.language;
    const { position_data } = PersonalRecordState({});

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('PersonnelManagement', permission);

    const [data, setData] = useState<any[]>([]);
    const [nationalityData, setNationalityData] = useState<any[]>([]);
    const [search, setSearch] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);

    const [nationalityId, setNationalityId] = useState<number>(0);
    const [gender, setGender] = useState<string>("0")
    const [position, setPosition] = useState<number>(0);
    const [department, setDepartment] = useState<number>(0);
    const [status, setStatus] = useState<string>("0");


    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")

    const [department_data, set_department_data] = useState<any[]>([]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    // const handleUpdateStatusOnline = async (id_employee: number) => {
    //     try {
    //         await EmployeeApi.updateStatusOnline(id_employee)
    //             .then((res) => {
    //                 if (res.status < 300) {
    //                     handleGetData(true);
    //                 }
    //             }).catch((error) => console.log(error))
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }
    const handleGetDepartment = async () => {
        let query = {}
        await OrganizationApi.list(query).then(res => {
            if (res.status < 300) {
                set_department_data(res.data?.data || [])
            }
        })
    }
    const handleGetNationality = async () => {
        await NationalityApi.getAll().then(res => {
            if (res.status < 300) {
                setNationalityData(res.data?.data || [])
            }
        }).catch(err => console.log(err)).finally(() => {

        })
    }
    const handleGetData = useCallback(async (not_loading?: boolean) => {
        let query: listType = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (nationalityId) query = { ...query, nationality: nationalityData?.find((x) => x?.id_nationality == nationalityId)?.nationality_name_th }
        if (status !== '0') query = { ...query, status: status }
        if (search) query = { ...query, search: search }
        if (department !== 0) query = { ...query, department: department }
        if (position !== 0) query = { ...query, position: position }
        if (gender !== '0') query = { ...query, gender: gender }
        !not_loading && dispatch(setLoading());
        await EmployeeApi.list(query)
            .then((res) => {
                if (res.status < 300) {
                    setTotalItems(res.data?.data?.meta?.totalItems || 0);
                    if (res.data.data?.items?.length > 0) {
                        setData(res.data.data?.items);
                    } else {
                        setData([]);
                    }
                }
            }).catch((error) => console.log(error))
            .finally(() => {
                setTimeout(() => {
                    dispatch(unsetLoading());
                }, 800)
            })
    }, [search, page, pageLimit, sortBy, sortType, position, status, department, gender, nationalityId])

    const handleGetReport = async () => {
        let query: any = {
            lang: currentLanguage === languageEnum.TH ? languageEnum.TH : 'eng',
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (nationalityId) query = { ...query, nationality: nationalityData?.find((x) => x?.id_nationality == nationalityId)?.nationality_name_th }
        if (status !== '0') query = { ...query, status: status }
        if (search) query = { ...query, search: search }
        if (department !== 0) query = { ...query, department: department }
        if (position !== 0) query = { ...query, position: position }
        if (gender !== '0') query = { ...query, gender: gender }
        dispatch(setLoading());
        await ReportApi.GetEmployeeTable(query).then((res) => {
            if (res.status < 300) {
                const response = res.data;
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'report-personnel-ibsc');
            }
        }).catch((error) => console.log(error)).finally(() => dispatch(unsetLoading()))
    }

    const headCells = [
        {
            id: "fullname", width: 200, disablePadding: false, align: 'center', label: t("PERSONAL_MANAGEMENT.TABLE.FULL_NAME")
        },
        {
            id: "employee_no", disablePadding: false, width: 240, align: "center", label: t("PERSONAL_MANAGEMENT.TABLE.OFFICER_NUMBER")
        },
        {
            id: "gender", disablePadding: false, align: "center", width: 141, label: t("PERSONAL_MANAGEMENT.TABLE.GENDER")
        },
        {
            id: "nationality", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.NATIONALITY")
        },
        {
            id: "position_name", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.JOB_POSITION")
        },
        {
            id: "department", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.DEPARTMENT")
        },
        // {
        //     id: "status_online", disablePadding: false, align: "center", width: 150, label: t("PERSONAL_MANAGEMENT.TABLE.USAGE_STATUS")
        // },
        {
            id: "modified_data", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.LAST_UPDATE_BY")
        },
        {
            id: "modified_date", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.CREATE_LAST_UPDATED")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 257, label: t("PERSONAL_MANAGEMENT.TABLE.STATUS")
        },
        {
            id: "s", disablePadding: false, align: "center", width: 80, class: matches, label: ""
        },
    ];
    const renderGender = (gender: string): string => {
        return currentLanguage === languageEnum.TH
            ? (gender === gender_enum.MAN ? gender_enum.MAN : gender_enum.GIRL)
            : (gender === gender_enum.MAN ? gender_enum_en.MAN : gender_enum_en.GIRL);
    }

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { fullname, id_employee, modified_id, created_id, employee_no, status_online, gender, department_eng, nationality, position_name, department, create_date, modified_date, status } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "start", label: fullname || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: employee_no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: gender ? renderGender(gender) : "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: nationality || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: currentLanguage === languageEnum.TH ? department || '-' : department_eng || "-",
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: <span className='flex justify-center items-center'>
                //         <SwitchCustom
                //             checked={status_online === 'active' ? true : false}
                //             onChange={() => id_employee && handleUpdateStatusOnline(id_employee)}
                //         />

                //     </span>,
                // },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_id || created_id || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: moment(modified_date || create_date || new Date()).add(543, 'year').format('l') || create_date || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label:
                        <StatusCustom
                            sx={{ whiteSpace: "nowrap" }}
                            disableMaxWidth={status !== 'บันทึกร่าง' && status !== 'เป็นบุคลากร'}
                            text={status === 'บันทึกร่าง' ? t("PERSONAL_MANAGEMENT.STATUS.DRAFT") : status === 'เป็นบุคลากร' ? t("PERSONAL_MANAGEMENT.STATUS.STAFF") : t("PERSONAL_MANAGEMENT.STATUS.END_OF_EMPLOYMENT")}
                            type={status === 'บันทึกร่าง' ? status : status === 'เป็นบุคลากร' ? status : 'สิ้นสุดการเป็นบุคลากร'}
                        />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    width: 300,
                    component: (
                        <>
                            {checkPermit.isView && (
                                <RemoveRedEyeOutlinedIcon
                                    sx={{ opacity: id_employee ? 1 : .4 }}
                                    className='cursor-pointer'
                                    onClick={() => {
                                        if (id_employee) {
                                            navigate(routeName.cms.PersonnelManagement + `-detail/${id_employee}`, {
                                                state: {
                                                    view: true
                                                }
                                            });
                                            dispatch(setStep(0));
                                        }
                                    }}
                                />
                            )}
                        </>
                    )
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetDepartment();
        handleGetNationality();
    }, [])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return (
        <div>
            <ContentHeading title={"TOPIC.PERSONNEL_MANAGEMENT"} detail='HEADING.SELECT_LIST' />
            <div className='w-full grid grid-cols-12 gap-4 mt-[40px]'>
                <article className='w-full col-span-12 md:col-span-12 lg:col-span-4'>
                    <InputTextField
                        startAdornment={<SearchOutlinedIcon />}
                        placeholder={t("PERSONAL_MANAGEMENT.FILTER.SEARCH")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch })}
                    />
                </article>
                <article className='col-span-12 md:col-span-6 lg:col-span-3'>
                    <FilterSelect
                        value={nationalityId}
                        labelId='nationalityId'
                        selectId='nationalityId'
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setNationalityId(+e.target.value)}
                        options={[
                            <MenuItem value={0}>{t("PERSONAL_MANAGEMENT.FILTER.ALL_NATIONALITY")}</MenuItem>,
                            nationalityData?.map((list: any) =>
                                <MenuItem
                                    key={list.id_nationality}
                                    value={list.id_nationality}>{currentLanguage === 'th' ? list.nationality_name_th : list.nationality_name_eng}
                                </MenuItem>
                            )
                        ]}
                    />
                </article>
                <article className='col-span-12 md:col-span-6 lg:col-span-3'>
                    <FilterSelect
                        value={gender}
                        labelId=''
                        selectId=''
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setGender(e.target.value)}
                        options={[
                            <MenuItem value={"0"}>{t("PERSONAL_MANAGEMENT.FILTER.ALL_GENDER")}</MenuItem>,
                            gender_data.map((list) => <MenuItem key={list.value} value={list.value}>{t(list.label)}</MenuItem>)
                        ]}
                    />
                </article>
                <article className="col-span-12 md:col-span-2 flex justify-start lg:justify-end">
                    {checkPermit.isCreated && (
                        <ButtonPrimary
                            onClick={() => {
                                navigate(routeName.cms.PersonnelManagementDetail);
                                dispatch(setStep(0));
                            }}
                            mode='add'
                            buttonName={t("PERSONAL_MANAGEMENT.BUTTON.ADD_PERSONNEL")}
                        />
                    )}
                </article>
            </div>
            <section className='grid grid-cols-12 gap-4 my-[1rem]'>
                <article className='col-span-12 md:col-span-6 lg:col-span-3'>
                    <AutocompleteSelect
                        placeholder={t("PERSONAL_MANAGEMENT.FILTER.ALL_POSITION")}
                        getOptionLabel={(option) => currentLanguage === 'th' ? option?.position_name || '' : option?.position_name || ''}
                        value={position_data.find((x: any) => x?.id_position === position) || null}
                        labelId=''
                        onChange={(_, value: any) => {
                            if (value) {
                                setPosition(value?.id_position)
                            } else {
                                setPosition(0)
                            }
                        }}
                        options={position_data || []}
                        isFilter
                    />
                </article>
                <article className='col-span-12 md:col-span-6 lg:col-span-4'>
                    <AutocompleteSelect
                        placeholder={t("PERSONAL_MANAGEMENT.FILTER.ALL_DEPARTMENT")}
                        value={department_data.find((x: any) => x?.id_department === department) || null}
                        labelId=''
                        onChange={(_, value: any) => {
                            if (value) {
                                setDepartment(value?.id_department)
                            } else {
                                setDepartment(0)
                            }
                        }}
                        getOptionLabel={(option) => currentLanguage === 'th' ? option?.department_name_th || '' : option?.department_name_eng || ''}
                        options={department_data || []}
                        isFilter
                    />
                </article>
                <article className='col-span-12 md:col-span-6 lg:col-span-3'>
                    <FilterSelect
                        value={status}
                        labelId=''
                        selectId=''
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStatus(e.target.value)}
                        options={[
                            <MenuItem value={"0"}>{t("PERSONAL_MANAGEMENT.FILTER.ALL_STATUS")}</MenuItem>,
                            status_employee_data?.map((list) => <MenuItem value={list.value} key={list.value}>{t(list.label)}</MenuItem>)
                        ]}
                    />
                </article>
                <article className='flex justify-end item-center col-span-12 md:col-span-6 lg:col-span-2'>
                    <DropdownButton
                        fullWidth
                        sx={{ whiteSpace: "nowrap" }}
                        // sx={{ fontSize: 'clamp(.3vw + 0.2vmin)'}}
                        buttonName={t("PERSONAL_MANAGEMENT.BUTTON.DOWNLOAD_FILE")}
                        menuItems={[
                            // { id: 1, name: "pdf", onClick: () => { alert("downloading...") } },
                            { id: 2, name: "excel", onClick: () => handleGetReport() },
                        ]}
                    />
                </article>
            </section>
            <section className='w-full mt-10'>
                <TableCustom
                    tableMinWidth={1920}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={data?.map((data: any, i: any) => {
                        return renderData(data, i)
                    })}
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </div>
    )
}

export default PersonnelManagement